import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const RelatedArticles = ({ articles }) => {
  if (!articles || articles.length === 0) return null;

  return (
    <Card className="mb-8" data-testid="related-articles-card">
      <CardHeader>
        <CardTitle>Related Articles from Platform</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {articles.map((relatedArticle) => (
            <Link
              key={relatedArticle.id}
              to={`/article/${relatedArticle.id}`}
              className="block hover:bg-slate-50 p-3 rounded-lg transition-colors border border-slate-200"
              data-testid={`related-article-${relatedArticle.id}`}
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h4 className="font-semibold text-slate-900 hover:text-blue-600 mb-1">{relatedArticle.title}</h4>
                  <div className="flex items-center space-x-3 text-sm text-slate-600">
                    {relatedArticle.journal && <span>{relatedArticle.journal}</span>}
                    {relatedArticle.publication_year && <span>{relatedArticle.publication_year}</span>}
                    {relatedArticle.normalized_study_type && (
                      <Badge variant="outline" className="text-xs">{relatedArticle.normalized_study_type}</Badge>
                    )}
                  </div>
                </div>
                {relatedArticle.impact_index && (
                  <div className="ml-4 text-right">
                    <div className="text-2xl font-bold text-blue-600">{relatedArticle.impact_index.toFixed(1)}</div>
                    <div className="text-xs text-slate-600">Impact Index</div>
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
